<template>
  <div class="u-radio-group">
    <div
      v-for="(option, i) in options"
      :key="`${name}-${i}`"
      class="radio-container"
    >
      <input
        type="radio"
        :name="name"
        :id="`${name}-${i}`"
        :value="option.value"
        :checked="option.value === value"
        class="radio"
        @change="$emit('change', option.value)"
      >
      <label :for="`${name}-${i}`" class="radio-label">
        <span class="radio-el"></span>
        <span class="radio-label-text">
          {{ option.label }}
        </span>
      </label>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      name: {
        type: String,
        required: true
      },
      value: {
        type: [String, Number],
        required: true
      },
      options: {
        type: Array,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .radio-container {
    position: relative;
    margin-bottom: 1em;
  }
  .radio-label {
    display: inline-flex;
    color: var(--ec-gray, lighten(black, 35));
    align-items: center;
    border: 1px solid var(--ec-gray-light, lighten(black, 85));
    padding: 1em .75em;
    border-radius: var(--ec-border-radius, 3px);
    width: 100%;
    cursor: pointer;
  }
  .radio {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
    &:checked + .radio-label {
      .radio-el {
        color: var(--ec-primary-color, black);
      }
      .radio-el:before {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
      }
    }
  }
  .radio-el {
    position: relative;
    width: 24px;
    height: 24px;
    margin-right: 1em;
    color: var(--ec-gray-light, lighten(black, 85));
    border: 1px solid;
    border-radius: 50%;
    &:before {
      content: '';
      position: absolute;
      width: 14px;
      height: 14px;
      top: 50%;
      left: 50%;
      background-color: var(--ec-primary-color, black);
      border-radius: 50%;
      opacity: 0;
      transform: translate(-50%, -50%) scale(1);
      transition: .2s cubic-bezier(0.390, 0.575, 0.565, 1.000);
    }
  }
</style>